export const STATE_IDENTIFIER = {
  SMS_ENABLED: "smsEnabled",
  SMS_MOBILE_NUMBER_EDITABLE_BY_USER: "smsMobileNumberEditableByUser",
  RETRYABLE_REQUEST_TYPES: "retryableRequestType",
  REQUESTS_HISTORY_FETCH_LIMIT: "requestHistoryCsvLimit",
  MODIFY_PROFILE_CA_OTP_ENABLED: "MODIFY_PROFILE_CA_OTP_ENABLED",
  MODIFY_PROFILE_SEC_QUESTIONS_ENABLED: "MODIFY_PROFILE_SEC_QUESTIONS_ENABLED",
  MODIFY_PROFILE_UIGP_OTP_ENABLED: "MODIFY_PROFILE_UIGP_OTP_ENABLED",
  DELEGATE_CONSULTANT_ENABLED: "DELEGATE_CONSULTANT_ENABLED",
};

export interface GlobalConfig {
  configuration: string;
  description: string;
  value: string;
}
